module.exports = __webpack_public_path__ + "img/clinets-fidelisés.ca4ae12b.svg";